<template>
  <div class="font-sans bg-gray-900 min-h-screen flex flex-col items-center">
    <!-- Header Section -->
    <header
      class="w-full bg-gradient-to-r from-gray-900 via-blue-500 to-gray-900 pt-12 pb-12 text-center shadow-lg relative overflow-hidden">
      <h1 class="neon-black text-6xl text-white text-center font-extrabold animate__animated animate__fadeInTopLeft">
        ¡Cupones de descuento como nunca los habias visto!</h1>

      <p class="mt-6 px-2 text-white text-xl max-w-4xl mx-auto animate__animated animate__fadeInBottomRight">
        Disfruta de descuentos increíbles en cientos de negocios, acumula puntos para recompensas exclusivas y tener la
        oportunidad de ganar cupones con premios adicionales. ¡Y lo mejor de todo! Puedes duplica tus cupones para
        utilizarlo en productos seleccionados.
      </p>
      <img src="@/assets/img/cupones7.png" alt="cupones" class="w-72 mx-auto mt-8 animate-bounce">


      <div
        class="bg-gradient-to-r from-gray-900 via-blue-500 to-gray-900 p-6 max-w-2xl border border-gray-200 mx-auto rounded-2xl shadow-md space-y-2"
        v-if="$route.name === 'cupon-digital'">
        <h2 class="text-2xl font-bold text-center text-gray-200 mb-4">Selecciona tu ubicación para ver los
          negocios
          participantes</h2>
        <div class="flex flex-wrap gap-4 justify-center">

          <!-- Select País -->
          <div class="w-full sm:w-auto">
            <label class="block mb-1 font-semibold text-gray-200">País</label>
            <select v-model="selectedCountry" @change="fetchStates"
              class="bg-white w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500">
              <option value="" disabled>Seleccione un país</option>
              <option v-for="pais in paises" :key="pais.id" :value="pais">
                {{ pais.nombre }}
              </option>
            </select>
          </div>

          <!-- Select Estado -->
          <div v-if="estados.length" class="w-full sm:w-auto">
            <label class="block mb-1 font-semibold text-gray-200">Estado</label>
            <select v-model="selectedState" @change="fetchMunicipios"
              class="bg-white w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500">
              <option value="" disabled>Seleccione un estado</option>
              <option v-for="estado in estados" :key="estado.id" :value="estado">
                {{ estado.nombre }}
              </option>
            </select>
          </div>

          <!-- Select Municipio -->
          <div v-if="municipios.length" class="w-full sm:w-auto">
            <label class="block mb-1 font-semibold text-gray-200">Municipio</label>
            <select v-model="selectedMunicipio" @change="fetchNegocios()"
              class="bg-white w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500">
              <option value="" disabled>Seleccione un municipio</option>
              <option v-for="municipio in municipios" :key="municipio.id" :value="municipio">
                {{ municipio.nombre }}
              </option>
            </select>
          </div>

        </div>
      </div>

    </header>

    <!-- Cómo Funciona Section 
    <section class="mt-16 max-w-4xl text-center px-6">
      <h2 class="text-4xl font-bold text-cyan-400">¿Cómo Los Obtengo?</h2>
      <ul class="mt-4 space-y-3 text-lg text-white">
        <li v-for="(item, index) in steps" :key="index"
          class="rounded-lg flex items-center justify-center transition-all duration-500 ease-in-out" :class="{
            'bg-yellow-500 scale-105 shadow-lg': activeIndex === index,
            'bg-gray-800': activeIndex !== index
          }">
          <span class="text-3xl mr-3 p-2">
            {{ item.icon }}
          </span>
          <span>{{ item.text }}</span>
        </li>
      </ul>
    </section> -->


    <!-- negocios participantes -->
    <h2 id="business-section" class="text-4xl mt-16 mb-4 px-2 font-bold text-cyan-400 text-center">Negocios
      participantes para aplicar tus cupones de descuento</h2>
    <p class="text-lg" v-if="nombreRegion !== null">
      <span class="text-white">Región </span><span class="font-bold text-white">{{ nombreRegion }}</span>
    </p>

    <!-- Mostrar negocios disponibles -->
    <section v-if="negocios.length"
      class="bg-gray-200 pt-4 pb-4 border border-gray-400 rounded-lg max-w-6xl grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 px-6 overflow-auto max-h-96 mt-4">
      <div v-for="negocio in negocios" :key="negocio.id" :class="[
        'relative flex flex-col justify-between items-center p-2 rounded-lg transition-all h-full bg-white hover:bg-gray-100',
        negocio.alto_impacto ? 'border-2 border-green-400 shadow-lg shadow-green-500' : ''
      ]" style="min-height: 220px;">

        <div class="flex flex-col items-center relative w-full">
          <!-- Etiqueta de descuento con espacio -->
          <div v-if="negocio.porcentaje"
            class="self-end mb-2 bg-red-500 text-white text-xs font-bold px-2 py-1 -mt-1 -mr-6 rotate-[35deg] rounded shadow-md z-10">
            {{ negocio.porcentaje }}% Desc.
          </div>

          <!-- Logo -->
          <img :src="negocio.logo_url" alt="Logo del negocio"
            class="w-full max-w-[120px] max-h-[120px] object-contain mb-2 rounded-lg" />

          <!-- Nombre -->
          <span class="text-center font-bold">{{ negocio.nombre }}</span>
        </div>


        <button @click.stop="mostrarInformacion(negocio)"
          class="mt-4 text-sm bg-blue-500 text-white px-3 py-1 rounded-full hover:bg-blue-600 w-full">
          ℹ️&nbsp;Información 
        </button>
      </div>

    </section>


    <!-- Imagen por defecto si no hay negocios -->
    <div v-if="mostrarNoNegocios" class="text-center mt-4">
      <img src="@/assets/img/proximamente.png" alt="Sin negocios" class="w-64 h-64 mx-auto mt-2">
    </div>

    <!-- Sección de Cupones Seleccionados 
    <section v-if="negociosSeleccionados.length"
      class="mt-6 bg-gray-100 p-6 rounded-2xl shadow-lg max-w-5xl mx-auto border border-gray-300">
      <h3 class="text-3xl font-extrabold mb-6 text-center text-cyan-500">🎉 Tus cupones seleccionados</h3>
      <div class="flex flex-wrap justify-center gap-6">
        <div v-for="negocio in negociosSeleccionados" :key="negocio.id" class="w-[280px] sm:w-[300px] bg-white p-4 rounded-2xl shadow-md border-2 border-dashed border-cyan-500 
                flex flex-col items-center gap-3 transition-transform hover:scale-105">

          <img :src="negocio.logo_url" alt="Logo del negocio"
            class="w-full max-w-[140px] max-h-[140px] object-contain rounded-lg shadow bg-white" />
          <span class="text-gray-600 text-center">Cupón de descuento para: </span>
          <span class="text-lg font-bold text-center text-gray-800">{{ negocio.nombre }}</span>
        </div>
      </div>

       Transición del botón 
      <transition name="fade-slide">
        <router-link v-if="negociosSeleccionados.length === 2" :to="registroRoute" class="block text-center mt-10 px-8 py-4 bg-green-500 text-white text-lg font-bold
                      rounded-br-xl rounded-tl-xl  shadow-xl hover:bg-green-600 transition-all duration-300">
          ¡Obtener cupones!
        </router-link>
      </transition>
    </section> -->


    <!-- Sólo mostrar cuando la liga tenga una región asociada -->
    <div class="p-6 max-w-2xl mx-auto bg-gray-100 rounded-2xl shadow-md space-y-2 mt-12"
      v-if="$route.name === 'cupon-digital-con-region'">
      <h2 class="text-2xl font-bold text-center text-gray-800 mb-4">
        Selecciona otra ubicación para ver los negocios participantes
      </h2>
      <div class="flex flex-wrap gap-4 justify-center">

        <!-- Select País -->
        <div class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">País</label>
          <select v-model="selectedCountry" @change="fetchStates"
            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="" disabled>Seleccione un país</option>
            <option v-for="pais in paises" :key="pais.id" :value="pais">
              {{ pais.nombre }}
            </option>
          </select>
        </div>

        <!-- Select Estado -->
        <div v-if="estados.length" class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">Estado</label>
          <select v-model="selectedState" @change="fetchMunicipios"
            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="" disabled>Seleccione un estado</option>
            <option v-for="estado in estados" :key="estado.id" :value="estado">
              {{ estado.nombre }}
            </option>
          </select>
        </div>

        <!-- Select Municipio -->
        <div v-if="municipios.length" class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">Municipio</label>
          <select v-model="selectedMunicipio" @change="fetchNegocios()"
            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="" disabled>Seleccione un municipio</option>
            <option v-for="municipio in municipios" :key="municipio.id" :value="municipio">
              {{ municipio.nombre }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <section class="mt-12 flex flex-col items-center justify-center bg-gray-200 p-8 rounded-lg shadow-lg space-y-4">
      <h2 class="text-2xl font-bold text-gray-800">¡Regístrate ahora gratis!</h2>
      <p class="text-lg text-gray-600">Recibirás tu saldo de descuento para aplicar en los negocios.
      </p>
      <section class="text-center">
        <router-link :to="registroRoute" class="text-center mt-8 inline-block px-6 py-3 bg-green-500 text-white font-bold rounded-lg
                          shadow-lg custom-shadow hover:bg-green-600 hover:shadow-xl transition-all
                          duration-300">
          ¡Registrate ahora!
        </router-link>
      </section>
    </section>



    <div class="bg-gradient-to-r from-gray-900 via-blue-500 to-gray-900 pt-8 mt-8 text-white w-full shadow-md">
      <!-- Título centrado arriba -->
      <h3 class="text-4xl font-bold mb-6 text-center">¡Invita a tus amigos y gana cupones GRATIS!</h3>

      <!-- Contenedor flexible -->
      <div class="flex flex-col md:flex-row items-center justify-center gap-8">
        <!-- Imagen a la izquierda -->
        <div class="flex-shrink-0">
          <img src="@/assets/img/cupones6.png" alt="cupones" class="w-60 h-40">
        </div>

        <!-- Texto y botón a la derecha -->
        <div class="text-center md:text-left">
          <p class="px-2 text-xl mb-4">Por cada amigo que se una al club, obtendrás 2 cupones adicionales.
            ¡Mientras más amigos invites, más cupones acumulas y mayores serán tus ahorros!
          </p>
          <p class="text-xl px-2 mb-2">¡No te quedes atrás! Comparte esta increíble oportunidad y disfruta de
            descuentos
            exclusivos ahora mismo. 🔥👥
          </p>

        </div>
      </div>
      <!-- Botón para ir a negocios participantes -->
      <div class="flex justify-center mb-12">
        <button @click="scrollToBusinesses"
          class="px-6 py-3 bg-blue-900 text-white rounded-lg text-lg font-semibold transition transform hover:scale-105">
          Ver Negocios Participantes
        </button>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  data() {
    return {
      paises: [],
      estados: [],
      municipios: [],
      negocios: [],
      selectedCountry: '',
      selectedState: '',
      selectedMunicipio: '',
      mostrarNoNegocios: false, // Nueva variable para controlar la visibilidad
      noPatrocinador: "",
      nombreRegion: null,
      negociosSeleccionados: [],

      activeIndex: 0,
      steps: [
        { icon: "1️⃣", text: "Elige 2 de los negocios participantes para tu descuento." },
        { icon: "2️⃣", text: "Dale click al boton de obtener cupones para poder recibir tus cupones." },
        { icon: "3️⃣", text: "¡Listo! ya puedes utilizar tus cupones en los negocios seleccionados." },
      ],

      inicioCupones: null,
      countdown: {
        dias: 0,
        horas: 0,
        minutos: 0,
        segundos: 0
      },
      intervaloCountdown: null
    };
  },
  props: {
    patrocinadores: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    // Obtener fecha de inicio de cupones y arrancar el contador
    async fetchInicioCupones() {
      await this.axios.get("/api/v2/cupones").then((response) => {
        if (response.data.inicio_cupones) {
          this.inicioCupones = new Date(response.data.inicio_cupones)
          this.startCountdown()
        } else {
          this.inicioCupones = null
        }
      }).catch(() => {
        this.inicioCupones = null
      })
    },

    startCountdown() {
      if (this.intervaloCountdown) clearInterval(this.intervaloCountdown)

      this.intervaloCountdown = setInterval(() => {
        const ahora = new Date()
        const diferencia = this.inicioCupones - ahora

        if (diferencia <= 0) {
          clearInterval(this.intervaloCountdown)
          this.countdown = { dias: 0, horas: 0, minutos: 0, segundos: 0 }
          return
        }

        const segundosTotales = Math.floor(diferencia / 1000)
        this.countdown.dias = Math.floor(segundosTotales / (60 * 60 * 24))
        this.countdown.horas = Math.floor((segundosTotales / (60 * 60)) % 24)
        this.countdown.minutos = Math.floor((segundosTotales / 60) % 60)
        this.countdown.segundos = segundosTotales % 60
      }, 1000)
    },

    // Alternar la selección de un negocio
    toggleNegocioSeleccionado(negocio) {
      const index = this.negociosSeleccionados.findIndex((n) => n.id === negocio.id)

      if (index !== -1) {
        // Si ya está seleccionado, lo deselecciona
        this.negociosSeleccionados.splice(index, 1)
      } else if (this.negociosSeleccionados.length < 2) {
        // Si no está seleccionado y hay espacio, lo selecciona
        this.negociosSeleccionados.push(negocio)
      } else {
        alert("Solo puedes seleccionar 2 cupones.")
      }
    },
    // Verificar si un negocio está seleccionado
    isSeleccionado(negocio) {
      return this.negociosSeleccionados.some((n) => n.id === negocio.id)
    },

    //Mostrar informacion del negocio
    mostrarInformacion(negocio) {
      const esUnaUbicacion = Array.isArray(negocio.ubicaciones) && negocio.ubicaciones.length === 1;
      const textoDirecciones = esUnaUbicacion ? 'Dirección' : 'Direcciones';
      this.$swal({
        title: '',
        html: `
    <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 15px;">
      <img src="${negocio.logo_url}" alt="Logo" style="max-width: 120px; max-height: 120px; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" />
      <h2 style="color: #111827; font-size: 1.5rem; font-weight: bold; margin-top: 12px;">${negocio.nombre}</h2>
    </div>

    <div style="text-align: left; color: #374151; font-size: 1rem;">

      <div style="display: flex; align-items: center; margin-bottom: 12px;">
        <p style="white-space: pre-wrap; text-align: justify;"><strong>📄 Descripción:</strong> ${negocio.descripcion || 'No especificada'}</p>
      </div>

      <div style="display: flex; align-items: center; margin-bottom: 6px;">
        <svg style="width: 20px; height: 20px; margin-right: 8px; color: #10B981;" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C8.1 2 5 5.1 5 9c0 5.3 7 13 7 13s7-7.7 7-13c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z"/>
        </svg>
        <strong>${textoDirecciones}:</strong>
      </div>

      <div style="display: flex; flex-direction: column; gap: 8px; margin-left: 28px; margin-top: 6px;">
        ${Array.isArray(negocio.ubicaciones)
            ? negocio.ubicaciones.map(direccion => `
              <div style="
                background-color: #5DE2E7;
                padding: 10px 14px;
                border-radius: 8px;
                box-shadow: 0 1px 4px rgba(0,0,0,0.05);
                display: flex;
                align-items: center;
                gap: 10px;
              ">
                
                <span>📍 ${direccion}</span>
              </div>
            `).join('')
            : '<div style="color: #515151;">No especificadas</div>'
          }
      </div>
    </div>
  `,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#D20103',
        background: '#FFFFFF',
        customClass: {
          popup: 'rounded-xl',
        }
      });
    },



    // Obtener países y estados
    async fetchCountries() {
      await this.axios.get("api/v2/negocios-gratuitos/regiones-disponibles.json").then((response) => {
        if (response.data.mapa) {
          this.paises = response.data.mapa
        } else {
          this.paises = []
        }
      }).catch(() => {
        this.paises = []
      })
    },

    // Obtener estados del país seleccionado
    fetchStates() {
      if (this.selectedCountry) {
        this.estados = this.selectedCountry.estados;
        this.municipios = []
        this.resetNegocios()
      }
    },

    // Obtener municipios del estado seleccionado
    fetchMunicipios() {
      if (this.selectedState) {
        this.municipios = this.selectedState.municipios;
        this.resetNegocios()
      }
    },

    // Obtener negocios del municipio seleccionado
    async fetchNegocios(id = null) {
      if (this.selectedMunicipio || id) {
        this.negociosSeleccionados = []
        const regionId = id || this.selectedMunicipio.id
        await this.axios.get(`api/v2/negocios-gratuitos/by-region/${regionId}.json`).then((response) => {
          this.nombreRegion = response.data.nombre_region
          if (response.data.negocios && response.data.negocios.length > 0) {
            this.negocios = response.data.negocios
            this.mostrarNoNegocios = false; // Ocultar mensaje si hay negocios
          } else {
            this.negocios = []
            this.mostrarNoNegocios = true // Mostrar mensaje si no hay negocios
          }
        }).catch(() => {
          this.negocios = []
          this.mostrarNoNegocios = true; // Mostrar mensaje en caso de error
        })
      }
    },
    //boton de scroll
    scrollToBusinesses() {
      const businessSection = this.$el.querySelector("#business-section")
      if (businessSection) {
        businessSection.scrollIntoView({ behavior: "smooth" })
      }
    },
    resetNegocios() {
      this.negocios = []
      this.nombreRegion = null
      this.negociosSeleccionados = []
      this.mostrarNoNegocios = false
    }
  },
  async mounted() {
    if (this.$route.params.noPatrocinador) {
      this.noPatrocinador = this.$route.params.noPatrocinador
    }
    if (this.$route.name === 'cupon-digital-con-region') {
      await this.fetchNegocios(Number(this.$route.params.regionId))
    }
    if (this.$route.name === 'campania') {
      this.negocios = this.patrocinadores
    } else {
      await this.fetchCountries()
    }
    await this.fetchInicioCupones()

    //puntos de como lo obtengo
    setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.steps.length;
    }, 1400); // Cambia cada 800 ms
  },
  computed: {
    registroRoute() {
      if (this.$route.name === 'campania') {
        return {
          name: 'registroCampania',
          params: { codigo: this.$route.params.codigo, patrocinadores: this.negociosSeleccionados.map(n => n.id) }
        }
      } else {
        return {
          name: 'registro',
          params: { noPatrocinador: this.noPatrocinador, patrocinadores: this.negociosSeleccionados.map(n => n.id) }
        }
      }
    }
  },
};

</script>

<style scoped>
/* Animaciones y estilos futuristas */
.neon-blanco {
  text-shadow: 0 0 10px #ffffff, 0 0 20px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
  text-shadow: 0 0 20px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.5s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>